(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["home"] && !Shopify.designMode) return;
  try {
    

var globalSelect = "";
function reset(){
      $('#slick-1496086189053').slick (
            {
        dots: true,
              slidesToShow: 1,
              slidesToScroll: 1,
              arrows: false,
              autoplay: false
            }
)
}

function process_slick_event(evt){
var _slick = $( "#" + evt.target.id);
$('#slick-1496086189053').slick('unslick');
var _slick2 = $(_slick.sectionId + " > " + "#slide-Adapted-Hero");
var attrLoc = $(evt.target.id);
console.log("PROCESS EVENT");
var selector = $(_slick.selector);
    switch ( evt.originalEvent.type ) {

      case "shopify:block:select" : 
      console.log(' Case: Selected ');

      console.log($(evt.target).index());
    $('#slick-1496086189053').slick({
      arrows: false,
      initialSlide: $(evt.target).index(),
    });
      break; 
      case "shopify:block:deselect" :
        console.log('Unload ');
        reset();

    
      break;

     } 

}

function reslicker(evt){
var _slick = $( "#" + evt.target.id);
 globalSelect = $(_slick.selector);
console.log("What what what");
var ah = $($(_slick.selector).find('#slick-1496086189053'))
console.log(ah.selector);
$(_slick.selector).find('#slick-1496086189053').data('autoplay', 'false');
$(_slick.selector).find('#slick-1496086189053').slick('unslick');
reset();

}

function slicker(){
     $('#slick-1496086189053').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
}
$(document)
 .on(   'shopify:block:select', process_slick_event )
 .on( 'shopify:block:deselect', process_slick_event )
 .on(   'shopify:section:select', reslicker )
 .on(   'shopify:section:reorder', reslicker )

;



  } catch(e) { console.error(e); }
})();
})();
